import InitApi from "api/InitApi";
import { useMutation } from "react-query";
import useTokenStore from "store/tokenStore";

const useTrackEngagement = (bookId) => {
	const { accessToken } = useTokenStore();

	const send = async (payload) => {
		// console.log("payload", payload);
		const instance = await InitApi({ accessToken });
		const body = {
			...payload,
			ts_client: new Date().toISOString(),
			referrer: document.referrer || undefined,
		};
		return instance.post(`/books/engagements/${bookId}`, body);
	};

	return useMutation(send);
};

export default useTrackEngagement;
